import { render } from "./PreviewCanvasComponent.vue?vue&type=template&id=798608e6&scoped=true&ts=true"
import script from "./PreviewCanvasComponent.vue?vue&type=script&lang=ts"
export * from "./PreviewCanvasComponent.vue?vue&type=script&lang=ts"

import "./PreviewCanvasComponent.vue?vue&type=style&index=0&id=798608e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798608e6"]])

export default __exports__